import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { GoogleCalendarIntegration, GoogleCalendarIntegrationUpdateSynced, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateSyncedCalendar(): UseMutationResult<
  AxiosResponse<GoogleCalendarIntegration>,
  AxiosError<ErrorMessage>,
  GoogleCalendarIntegrationUpdateSynced
> {
  const queryClient = useQueryClient();

  const updateSyncedCalendar = useCallback(
    (
      googleCalendarIntegration: GoogleCalendarIntegrationUpdateSynced,
    ): Promise<AxiosResponse<GoogleCalendarIntegration>> => {
      return client.put(
        `google-calendar-integrations/${googleCalendarIntegration.googleCalendarIntegrationId}/synced-calendar/`,
        googleCalendarIntegration,
      );
    },
    [],
  );

  return useMutation(updateSyncedCalendar, {
    onSuccess: () => {
      queryClient.invalidateQueries(['google-calendar-integrations']);
      queryClient.invalidateQueries(['google-calendars']);
    },
  });
}
